<template>
	<div :class="`content-actions ${variant === 'blue'? 'content-actions-blue':''}`">
		<slot></slot>
	</div>
</template>
<script>
export default {
	props:{
		variant:function (value) {
			if (!value) return true
      return ['blue'].includes(value)
    },
	},
}
</script>
<style>
	.content-actions{
		margin-top:-2px;
		background-color:#B61D1D;
		padding:0.5rem 1rem;
		overflow-x:scroll;
		white-space: nowrap;
		position:relative;
		z-index:900;
	}
	.content-actions.content-actions-blue{
		background-color:#1A75D3;
	}
	.content-actions button{
		position:relative;
		display:inline-block;
	}
	.content-actions i{
		position:relative;
		top:-1px;
	}
</style>


// WEBPACK FOOTER //
// src/components/content/content-actions.vue